module.exports = __webpack_public_path__ + "img/18ce1c0.png";